const Supplier = {
  Supplier: "Supplier.Supplier",
  Suppliers: "Supplier.Suppliers",
  Search: "Supplier.Search",
  LeftToPay: "Supplier.LeftToPay",
  TodoDescription: "Supplier.TodoDescription",
  HelpTextName: "Supplier.HelpTextName",
  HelpTextRating: "Supplier.HelpTextRating",
  HelpTextRules: "Supplier.HelpTextRules",
  HelpTextNumOfInvoices: "Supplier.HelpTextNumOfInvoices",
  HelpTextInvoicedTotal: "Supplier.HelpTextInvoicedTotal",
  HelpTextDue: "Supplier.HelpTextDue",
  HasRules: "Supplier.HasRules",
  HasUnpaidInvoices: "Supplier.HasUnpaidInvoices",
  NumberOfInvoices: "Supplier.NumberOfInvoices",
  PaymentTermsHelpText: "Supplier.PaymentTermsHelpText",
  RulePeriod_0: "Supplier.RulePeriod_0",
  RulePeriod_1: "Supplier.RulePeriod_1",
  RulePeriod_2: "Supplier.RulePeriod_2",
  EmailDialogHeader: "Supplier.EmailDialogHeader",
  EmailDialogTitle: "Supplier.EmailDialogTitle",
  EmailDialogSubTitle: "Supplier.EmailDialogSubTitle",
  EmailSendSuccessMessage: "Supplier.EmailSendSuccessMessage",
  AddRuleDialogSubTitle: "Supplier.AddRuleDialogSubTitle",
  DimensionsHelpText: "Supplier.DimensionsHelpText",
  BookingAccountHelpText: "Supplier.BookingAccountHelpText",
  ActiveHelpText: "Supplier.ActiveHelpText",
  RulePeriodHelpText: "Supplier.RulePeriodHelpText",
  HighestAmountHelpText: "Supplier.HighestAmountHelpText",
  LowestAmountHelpText: "Supplier.LowestAmountHelpText",
  PostedAs: "Supplier.PostedAs",
  SuppliersPerMonth: "Supplier.SuppliersPerMonth",
  Top3MonthlyCost: "Supplier.Top3MonthlyCost",
  SupplierUpdated: "Supplier.SupplierUpdated",
  AddRule: "Supplier.AddRule",
  DefaultPeriodisation: "Supplier.DefaultPeriodisation",
  DefaultPeriodisationLabel: "Supplier.DefaultPeriodisationLabel",
  DefaultPeriodisationHelpText: "Supplier.DefaultPeriodisationHelpText",
  DefaultPeriodisationHelpTextAnyAmount: "Supplier.DefaultPeriodisationHelpTextAnyAmount",
  DefaultPeriodisationInvalid: "Supplier.DefaultPeriodisationInvalid",
  DefaultPeriodisationSaveFailed: "Supplier.DefaultPeriodisationSaveFailed",
  }
export default Supplier;